import {connect} from "react-redux";

import {postMessageToParent} from "../lookMessaging";
import {GROHE_POST_MESSAGES_ACTIONS} from "../iframeIntegration";
import {getLookList} from "../lookNavigation/lookFunctions";
import {getDbFeatureProperty, getLookId} from "../lookNavigation/lookFunctions2";

const WithExitPostMessage = (props) => {

  const {bvPresets, children, activePreset, presetWasChangedByUser, firstLoadedPreset} = props;

  const exitPostMessage = () => {
    let sourceChanged = "False";
    let sourceChangeType = "";
    let variantUrl = "";
    if (Number.isInteger(presetWasChangedByUser)) {
      sourceChanged = "True";
      sourceChangeType = "Looks";
    } else if (Number.isInteger(firstLoadedPreset)) {
      const defaultPreset = bvPresets.find(preset => preset.id === firstLoadedPreset);
      if (defaultPreset) {
        const featureGroups = getLookList(true);
        // console.log("featureGroups", featureGroups);

        let changedFeature = null;
        featureGroups.find(parentObject => {
          if (!parentObject.featureGroup) {
            return false
          }
          if (parentObject.featureGroup.layerPositions) {
            Object.keys(parentObject.featureGroup.layerPositions).forEach(position => {
              const currentSelected = parentObject.featureGroup.layerPositions[position];
              const fromPreset = defaultPreset[parentObject.partId + "_" + position];
              if (currentSelected && fromPreset && (currentSelected.dbFeature.id !== fromPreset)) {
                changedFeature = currentSelected;
              }
            });
            if (changedFeature) {
              return true
            }
          } else if (parentObject.cartFeature && (parentObject.cartFeature.dbFeature.id !== defaultPreset[parentObject.partId])) {
            changedFeature = parentObject.cartFeature;
            return true
          }
          return false
        })
        // console.log("changedFeature", changedFeature);
        if (changedFeature) {
          const preparedVariantUrl = decodeURIComponent(
            changedFeature.dbFeature[getDbFeatureProperty("lixilVariantUrl")] || ""
          ).split("grohe.us") || ""
          sourceChanged = "True";
          sourceChangeType = "SKU";
          variantUrl = preparedVariantUrl[1] || preparedVariantUrl;
        }
      }
    }

    let lookId = getLookId(activePreset, bvPresets)
    let postData = {
      "EventType": GROHE_POST_MESSAGES_ACTIONS.exit,
      "SourceChanged": sourceChanged,
      "SourceChangeType": sourceChangeType,
      "LookId": lookId + "",
      "VariantUrl": variantUrl
    }
    postMessageToParent(postData);
  }

  return children(exitPostMessage)
};

const mapStateToProps = (store) => {
  const {bvPresets, activePreset, presetWasChangedByUser, firstLoadedPreset} = store.bathroomVisualizerState;
  return {
    bvPresets,
    activePreset,
    presetWasChangedByUser,
    firstLoadedPreset,
  }
};

export default connect(mapStateToProps)(WithExitPostMessage)
